export default {
  goodType: 'نوع کالا',
  packing: 'بسته بندی',
  packageCount: 'تعداد بسته',
  region: 'ناحیه',
  street: 'خیابان',
  receiver: 'گیرنده',
  addNewReciever: 'افزودن گیرنده جدید',
  personalityId: 'شناسه شخص',
  nationalId: 'کدملی',
  recieverAddress: 'آدرس گیرنده',
  recieverPhone: 'تلفن گیرنده',
  recieverMobile: 'موبایل گیرنده',
  recieverName: 'نام گیرنده',
  recieverNationalId: 'کدملی گیرنده',
  recieverRegionId: 'منقطه گیرنده',
  recieverPersonalityId: 'شخص گیرنده',
  recieverStreetId: 'خیابان گیرنده',
  recieverZipCode: 'کدپستی گیرنده',
  trackingCode: 'کد پیگیری',
  trackingId: 'شناسه پیگیری'
}
